<template>
  <div class="personal">
    <div class="personal__maint">Traveller's Profile</div>
    <div class="accordion">
      <button
        @click="show_common = !show_common"
        class="accordion__header"
        :class="{ 'accordion__header--show': show_common }"
      >
        <svg
          class="accordion__icon"
          :class="{ 'accordion__icon--complited': isCommonFilled === Object.keys(common).length }"
          width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="8" fill="#77B017"/>
          <path d="M7.063 10.884a.415.415 0 0 1-.288.116.415.415 0 0 1-.29-.116L4.18 8.656a.577.577 0 0 1 0-.836l.288-.28a.628.628 0 0 1 .867 0l1.44 1.391 3.89-3.758a.628.628 0 0 1 .867 0l.288.28c.24.23.24.605 0 .836l-4.757 4.595Z" fill="#fff"/>
        </svg>
        <span class="accordion__title">Common Data</span>
      </button>
      <transition name="slide-small">
        <div v-if="show_common" class="accordion__body">
          <form class="accordion__form">
            <div class="accordion__row accordion__row--mix-5">
              <app-form-group label="Content language">
                <app-select
                  v-model="common.content_language"
                  :reduce="item => item.code"
                  :options="languages_common_options"
                  :filterable="false"
                  :clearable="false"
                  :searchable="false"
                  placeholder="Category"
                />
              </app-form-group>
              <app-form-group label="Category">
                <app-select
                  v-model="common.category"
                  :reduce="item => item.code"
                  :options="categories_options"
                  :filterable="false"
                  :searchable="false"
                  placeholder="Category"
                />
              </app-form-group>
            </div>
            <app-cells v-if="is_general_manager || is_sales_manager" :indent="false" position="end">
              <app-button @click.native="onCheckForm(common, 'common')" ref="submit_common">
                Save
              </app-button>
            </app-cells>
          </form>
        </div>
      </transition>
    </div>
    <div class="accordion">
      <button
        @click="show_personal = !show_personal"
        class="accordion__header"
        :class="{ 'accordion__header--show': show_personal }"
      >
        <svg
          class="accordion__icon"
          :class="{ 'accordion__icon--complited': personal.personal_data_percentage === 100 }"
          width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="8" fill="#77B017"/>
          <path d="M7.063 10.884a.415.415 0 0 1-.288.116.415.415 0 0 1-.29-.116L4.18 8.656a.577.577 0 0 1 0-.836l.288-.28a.628.628 0 0 1 .867 0l1.44 1.391 3.89-3.758a.628.628 0 0 1 .867 0l.288.28c.24.23.24.605 0 .836l-4.757 4.595Z" fill="#fff"/>
        </svg>
        <span class="accordion__title">
          Personal Details
        </span>
      </button>
      <transition name="slide">
        <div v-if="show_personal" class="accordion__body">
          <form class="accordion__form">
            <div class="accordion__part">
              <div class="accordion__name">
                <img src="@/assets/img/personal-details.svg" alt="personal">
                <span>Personal Details</span>
              </div>
              <div class="accordion__row accordion__row--mix-1">
                <app-form-group label="First name" label-for="first_name">
                  <app-input
                      v-model="personal.first_name"
                      id="first_name"
                      placeholder="John"
                      @input="onChangeRUToUS($event, 'first_name')"
                      name="first_name"
                  />
                </app-form-group>
                <app-form-group label="Last name" label-for="last_name">
                  <app-input
                      v-model="personal.last_name"
                      id="last_name"
                      placeholder="Doe"
                      @input="onChangeRUToUS($event, 'last_name')"
                      name="last_name"
                  />
                </app-form-group>
                <app-form-group label="Date of birth">
                  <app-date-picker
                    v-model="personal.dob"
                    placeholder="Specify a date"
                    :error="$v.personal.dob.$error"
                  />
                  <template #error>
                    <div v-if="$v.personal.dob.$dirty && !$v.personal.dob.minValue">Year of birth cannot be less than 1930</div>
                    <div v-if="$v.personal.dob.$dirty && !$v.personal.dob.maxValue">Date of birth cannot be greater than the current date</div>
                  </template>
                </app-form-group>
                <app-form-group label="Gender" class="form-group--center">
                  <app-cells :indent="false">
                    <app-radio
                        v-for="item in genders_options"
                        :key="item.code"
                        v-model.number="personal.gender"
                        :value="item.code"
                        name="gender"
                        :checked="personal.gender"
                    >
                      <template #label>{{ item.name }}</template>
                    </app-radio>
                  </app-cells>
                </app-form-group>
              </div>
              <div class="accordion__row accordion__row--mix-2">
                <app-form-group label="Citizenship">
                  <app-select
                    v-model="personal.citizenship"
                    :reduce="item => item.code"
                    :options="countries_options"
                    :clearable="false"
                    placeholder="Citizenship"
                  />
                </app-form-group>
                <app-form-group label="Residence">
                  <app-select
                    v-model="personal.residence"
                    :reduce="item => item.code"
                    :options="residences_options"
                    :clearable="false"
                    placeholder="Residence"
                  />
                </app-form-group>
                <app-form-group label="Speaking language">
                  <app-select
                    v-model="personal.speaking_language"
                    :reduce="item => item.code"
                    :options="languages_options"
                    :clearable="false"
                    placeholder="Language"
                  />
                </app-form-group>
                <app-form-group v-if="is_general_manager || is_sales_manager" label="Passport number" label-for="passport">
                  <app-input
                      v-model="personal.passport"
                      id="passport"
                      placeholder="-- ------"
                      name="passport"
                  />
                </app-form-group>
                <app-form-group v-if="is_general_manager || is_sales_manager" label="Passport expiry date">
                  <app-date-picker
                    v-model="personal.passport_expiration_date"
                    placeholder="Specify a date"
                    :error="$v.personal.passport_expiration_date.$error"
                  />
                  <template #error>
                    <div v-if="$v.personal.passport_expiration_date.$dirty && !$v.personal.passport_expiration_date.minValue">
                      Date cannot be less than the current date
                    </div>
                  </template>
                </app-form-group>
              </div>
              <template v-if="requirements.passport_required || requirements.residence_permit_required">
                <app-info-text-panel>
                  The client is eligible for discounted entry permits to national parks on their program. Please upload scanned copies of the following documents:
                </app-info-text-panel>
                <div class="accordion__row accordion__row--mix-2">
                  <app-form-group v-if="requirements.passport_required" label="Passport">
                    <app-uploader v-model="personal.passport_copy" :extensions="['application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']" />
                  </app-form-group>
                  <app-form-group v-if="requirements.residence_permit_required" label="Residence permit">
                    <app-uploader v-model="personal.residence_permit_copy" :extensions="['application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']" />
                  </app-form-group>
                </div>
              </template>
              <app-form-group v-if="climbing_insurance_required || medical_clearance_required">
                <app-cropper-web-cam
                  v-model="personal.crop"
                  :aspectRatio="3/4"
                  ref="cropper"
                />
              </app-form-group>
            </div>
            <div v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_supervisor" class="accordion__part">
              <div class="accordion__name">
                <img src="@/assets/img/contact-details.svg" alt="contacts">
                <span>Contact Details</span>
              </div>
              <div class="accordion__row accordion__row--type-200">
                <app-form-group label="Email" label-for="email">
                  <app-input
                      v-model="personal.email"
                      @change.native="$v.personal.email.$touch"
                      :error="$v.personal.email.$error"
                      id="email"
                      type="email"
                      placeholder="mail@example.com"
                      name="email"
                  />
                  <template #error>
                    <div v-if="$v.personal.email.$dirty && !$v.personal.email.email">Enter the correct e-mail format</div>
                  </template>
                </app-form-group>
                <app-form-group label="Phone number">
                  <app-phone
                      @change.native="$v.personal.phone.$touch()"
                      v-model="personal.phone"
                      :error="$v.personal.phone.$dirty && personal.phone === 0"
                      placeholder="+7 499 113 28 00"
                  />
                  <template #error>
                    <div v-if="$v.personal.phone.$dirty && personal.phone === 0">
                      Invalid phone number format
                    </div>
                  </template>
                </app-form-group>
                <app-form-group label="Messengers" class="form-group--center">
                  <app-cells :indent="false">
                    <app-checkbox v-model="personal.phone_telegram" label="Telegram" :readonly="!personal.phone" />
                    <app-checkbox v-model="personal.phone_whatsapp" label="Whatsapp" :readonly="!personal.phone" />
                  </app-cells>
                </app-form-group>
              </div>
              <div class="accordion__name">
                <img src="@/assets/img/emer-contacts.svg" alt="personal">
                <span>Emergency Contact Details</span>
              </div>
              <div class="accordion__row accordion__row--type-200">
                <app-form-group label="Contact name" label-for="emergency_full_name">
                  <app-input
                      v-model="personal.emergency_contact_fullname"
                      id="emergency_full_name"
                      placeholder="John Doe"
                      name="emergency_full_name"
                  />
                </app-form-group>
                <app-form-group label="Contact email" label-for="emergency_email">
                  <app-input
                      v-model="personal.emergency_contact_email"
                      @change.native="$v.personal.emergency_contact_email.$touch"
                      :error="$v.personal.emergency_contact_email.$error"
                      id="emergency_email"
                      type="email"
                      placeholder="mail@example.com"
                      name="emergency_email"
                  />
                  <template #error>
                    <div v-if="$v.personal.emergency_contact_email.$dirty && !$v.personal.emergency_contact_email.email">
                      Enter the correct e-mail format
                    </div>
                  </template>
                </app-form-group>
                <app-form-group label="Contact phone">
                  <app-phone
                      @change.native="$v.personal.emergency_contact_phone.$touch()"
                      v-model="personal.emergency_contact_phone"
                      placeholder="+7 499 113 28 00"
                      :error="$v.personal.emergency_contact_phone.$dirty && personal.emergency_contact_phone === 0"
                  />
                  <template #error>
                    <div v-if="$v.personal.emergency_contact_phone.$dirty && personal.emergency_contact_phone === 0">
                      Invalid phone number format
                    </div>
                  </template>
                </app-form-group>
                <app-form-group label="Messengers" class="form-group--center">
                  <app-cells :indent="false">
                    <app-checkbox
                        v-model="personal.emergency_contact_phone_telegram"
                        label="Telegram"
                        :readonly="!personal.emergency_contact_phone"
                    />
                    <app-checkbox
                        v-model="personal.emergency_contact_phone_whatsapp"
                        label="Whatsapp"
                        :readonly="!personal.emergency_contact_phone"
                    />
                  </app-cells>
                </app-form-group>
              </div>
            </div>
            <div class="accordion__part">
              <div class="accordion__name">
                <img src="@/assets/img/food-preference.svg" alt="food">
                <span>Dietary Requirements</span>
              </div>
              <div class="accordion__row accordion__row--mix-diet">
                <app-form-group label="Diet">
                  <app-select
                    v-model="personal.food_preference"
                    :options="food_options"
                    :clearable="false"
                    placeholder="Diet"
                  />
                </app-form-group>
                <app-form-group label="Allergies" class="form-group--switcher">
                  <app-switcher v-model="allergies_switcher" />
                </app-form-group>
                <app-form-group label="Lactose free" class="form-group--switcher">
                  <app-switcher v-model="personal.food_lactose_free" />
                </app-form-group>
                <app-form-group label="Gluten free" class="form-group--switcher">
                  <app-switcher v-model="personal.food_gluten_free" />
                </app-form-group>
                <template v-if="personal.food_preference && personal.food_preference.is_meat">
                  <app-form-group label="Halal" class="form-group--switcher">
                    <app-switcher v-model="personal.food_halal" />
                  </app-form-group>
                  <app-form-group label="No red meat" class="form-group--switcher">
                    <app-switcher v-model="personal.food_no_red_meat" />
                  </app-form-group>
                  <app-form-group label="No chicken" class="form-group--switcher">
                    <app-switcher v-model="personal.food_no_chicken" />
                  </app-form-group>
                </template>
              </div>
              <div v-if="allergies_switcher" class="accordion__row accordion__row--mix-7">
                <app-form-group v-if="allergies_switcher" label="Food allergies" label-for="food">
                  <app-input
                    v-model="personal.food_allergy"
                    id="food"
                    placeholder="Food allergies"
                    name="food"
                  />
                </app-form-group>
              </div>
            </div>
            <app-cells v-if="is_general_manager || is_sales_manager || is_sales_supervisor" :indent="false" position="end">
              <app-button @click.native="onCheckForm(personal, 'personal')" ref="submit_personal">
                Save
              </app-button>
            </app-cells>
          </form>
        </div>
      </transition>
    </div>
    <div v-if="climbing_insurance_required" class="accordion">
      <button @click="show_climbing = !show_climbing" class="accordion__header" :class="{ 'accordion__header--show': show_climbing }">
        <svg
            class="accordion__icon"
            :class="{ 'accordion__icon--complited': isClimbingFilled === Object.keys(climbing_insurance).length }"
            width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="8" fill="#77B017"/>
          <path d="M7.063 10.884a.415.415 0 0 1-.288.116.415.415 0 0 1-.29-.116L4.18 8.656a.577.577 0 0 1 0-.836l.288-.28a.628.628 0 0 1 .867 0l1.44 1.391 3.89-3.758a.628.628 0 0 1 .867 0l.288.28c.24.23.24.605 0 .836l-4.757 4.595Z" fill="#fff"/>
        </svg>
        <span class="accordion__title">
          Climbing Insurance
        </span>
      </button>
      <transition name="slide-small">
        <div v-if="show_climbing" class="accordion__body">
          <form class="accordion__form">
            <div class="accordion__row accordion__row--mix-4">
              <app-form-group label="Name of insurance company" label-for="climbing_insurance_company" required>
                <app-input
                    v-model="climbing_insurance.climbing_insurance_company"
                    id="climbing_insurance_company"
                    placeholder="Name of insurance company"
                    :error="$v.climbing_insurance.climbing_insurance_company.$error"
                    name="climbing_insurance_company"
                />
                <template #error>
                  <div v-if="$v.climbing_insurance.climbing_insurance_company.$dirty && !$v.climbing_insurance.climbing_insurance_company.required">
                    Required field
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Personal policy number" label-for="climbing_insurance_number" required>
                <app-input
                    v-model="climbing_insurance.climbing_insurance_number"
                    id="climbing_insurance_number"
                    placeholder="--- ------"
                    :error="$v.climbing_insurance.climbing_insurance_number.$error"
                    name="climbing_insurance_number"
                />
                <template #error>
                  <div v-if="$v.climbing_insurance.climbing_insurance_number.$dirty && !$v.climbing_insurance.climbing_insurance_number.required">
                    Required field
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Valid from" required>
                <app-date-picker
                  v-model="climbing_insurance.climbing_insurance_coverage_start"
                  placeholder="Specify a date"
                  :error="$v.climbing_insurance.climbing_insurance_coverage_start.$error"
                />
                <template #error>
                  <div v-if="$v.climbing_insurance.climbing_insurance_coverage_start.$dirty && !$v.climbing_insurance.climbing_insurance_coverage_start.required">
                    Required field
                  </div>
                  <div v-if="$v.climbing_insurance.climbing_insurance_coverage_start.$dirty && !$v.climbing_insurance.climbing_insurance_coverage_start.maxValue">
                    The start date of the insurance must not be greater than the end date of the insurance
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Valid until" required>
                <app-date-picker
                  v-model="climbing_insurance.climbing_insurance_coverage_end"
                  placeholder="Specify a date"
                  :error="$v.climbing_insurance.climbing_insurance_coverage_end.$error"
                />
                <template #error>
                  <div v-if="$v.climbing_insurance.climbing_insurance_coverage_end.$dirty && !$v.climbing_insurance.climbing_insurance_coverage_end.required">
                    Required field
                  </div>
                  <div v-if="$v.climbing_insurance.climbing_insurance_coverage_end.$dirty && !$v.climbing_insurance.climbing_insurance_coverage_end.minValue">
                    Date cannot be less than the current date
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Emergency hotline">
                <app-phone
                    v-model="climbing_insurance.climbing_insurance_emergency_phone"
                    placeholder="+7 499 113 28 00"
                    :error="$v.climbing_insurance.climbing_insurance_emergency_phone.$dirty && (climbing_insurance.climbing_insurance_emergency_phone === 0)"
                />
                <template #error>
                  <div v-if="$v.climbing_insurance.climbing_insurance_emergency_phone.$dirty && (climbing_insurance.climbing_insurance_emergency_phone === 0)">
                    Invalid phone number format
                  </div>
                </template>
              </app-form-group>
            </div>
            <app-cells v-if="is_general_manager || is_sales_manager" :indent="false" :position="!climbing_insurance.climbing_insurance_company && safari_insurance_required ? 'between' : 'end'">
              <app-button
                v-if="!climbing_insurance.climbing_insurance_company && safari_insurance_required"
                @click.native="onCopyInsurance(safari_insurance, 'climbing', 'safari')"
                type="button"
              >
                <img src="@/assets/img/safari-btn-icon.svg" alt="Copy">
                Copy from safari
              </app-button>
              <app-button @click.native="onCheckForm(climbing_insurance, 'climbing')" ref="submit_climbing">
                Save
              </app-button>
            </app-cells>
          </form>
        </div>
      </transition>
    </div>
    <div v-if="safari_insurance_required" class="accordion">
      <button @click="show_safari = !show_safari" class="accordion__header" :class="{ 'accordion__header--show': show_safari }">
        <svg
            class="accordion__icon"
            :class="{ 'accordion__icon--complited': isSafariFilled === Object.keys(safari_insurance).length }"
            width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="8" fill="#77B017"/>
          <path d="M7.063 10.884a.415.415 0 0 1-.288.116.415.415 0 0 1-.29-.116L4.18 8.656a.577.577 0 0 1 0-.836l.288-.28a.628.628 0 0 1 .867 0l1.44 1.391 3.89-3.758a.628.628 0 0 1 .867 0l.288.28c.24.23.24.605 0 .836l-4.757 4.595Z" fill="#fff"/>
        </svg>
        <span class="accordion__title">Safari Insurance</span>
      </button>
      <transition name="slide-small">
        <div v-if="show_safari" class="accordion__body">
          <form class="accordion__form">
            <div class="accordion__row accordion__row--mix-4">
              <app-form-group label="Name of insurance company" label-for="safari_insurance_company" required>
                <app-input
                    v-model="safari_insurance.safari_insurance_company"
                    id="safari_insurance_company"
                    placeholder="Name of insurance company"
                    :error="$v.safari_insurance.safari_insurance_company.$error"
                    name="safari_insurance_company"
                />
                <template #error>
                  <div v-if="$v.safari_insurance.safari_insurance_company.$dirty && !$v.safari_insurance.safari_insurance_company.required">
                    Required field
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Personal policy number" label-for="safari_insurance_number" required>
                <app-input
                    v-model="safari_insurance.safari_insurance_number"
                    id="safari_insurance_number"
                    placeholder="--- ------"
                    :error="$v.safari_insurance.safari_insurance_number.$error"
                    name="safari_insurance_number"
                />
                <template #error>
                  <div v-if="$v.safari_insurance.safari_insurance_number.$dirty && !$v.safari_insurance.safari_insurance_number.required">
                    Required field
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Valid from" required>
                <app-date-picker
                  v-model="safari_insurance.safari_insurance_coverage_start"
                  placeholder="Specify a date"
                  :error="$v.safari_insurance.safari_insurance_coverage_start.$error"
                />
                <template #error>
                  <div v-if="$v.safari_insurance.safari_insurance_coverage_start.$dirty && !$v.safari_insurance.safari_insurance_coverage_start.required">
                    Required field
                  </div>
                  <div v-if="$v.safari_insurance.safari_insurance_coverage_start.$dirty && !$v.safari_insurance.safari_insurance_coverage_start.maxValue">
                    The start date of the insurance must not be greater than the end date of the insurance
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Valid until" required>
                <app-date-picker
                  v-model="safari_insurance.safari_insurance_coverage_end"
                  placeholder="Specify a date"
                  :error="$v.safari_insurance.safari_insurance_coverage_end.$error"
                />
                <template #error>
                  <div v-if="$v.safari_insurance.safari_insurance_coverage_end.$dirty && !$v.safari_insurance.safari_insurance_coverage_end.required">
                    Required field
                  </div>
                  <div v-if="$v.safari_insurance.safari_insurance_coverage_end.$dirty && !$v.safari_insurance.safari_insurance_coverage_end.minValue">
                    Date cannot be less than the current date
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Emergency hotline">
                <app-phone
                    v-model="safari_insurance.safari_insurance_emergency_phone"
                    placeholder="+7 499 113 28 00"
                    :error="$v.safari_insurance.safari_insurance_emergency_phone.$dirty && (safari_insurance.safari_insurance_emergency_phone === 0)"
                />
                <template #error>
                  <div v-if="$v.safari_insurance.safari_insurance_emergency_phone.$dirty && (safari_insurance.safari_insurance_emergency_phone === 0)">
                    Invalid phone number format
                  </div>
                </template>
              </app-form-group>
            </div>
            <app-cells v-if="is_general_manager || is_sales_manager" :indent="false" :position="!safari_insurance.safari_insurance_company && climbing_insurance_required ? 'between' : 'end'">
              <app-button
                v-if="!safari_insurance.safari_insurance_company && climbing_insurance_required"
                @click.native="onCopyInsurance(climbing_insurance, 'safari', 'climbing')"
                type="button"
              >
                <img src="@/assets/img/climbing-btn-icon.svg" alt="Copy">
                Copy from climbing
              </app-button>
              <app-button @click.native="onCheckForm(safari_insurance, 'safari')" ref="submit_safari">
                Save
              </app-button>
            </app-cells>
          </form>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {
  getClientsCategories,
  getClientsTourOperatorManagers,
  getClientsTourOperators,
  getCountries,
  getFoodPreferences,
  getGenders,
  getLanguages,
  getResidences,
  getUsers,
  patchClients,
} from '@/http'
import { email, required } from 'vuelidate/lib/validators'
import 'vue2-datepicker/locale/ru'
import 'vue2-datepicker/locale/en'
import AppInfoTextPanel from '@/components/AppInfoTextPanel'

export default {
  name: 'Personal',
  components: { AppInfoTextPanel },
  props: {
    common: {
      type: Object
    },
    personal: {
      type: Object
    },
    climbing_insurance: {
      type: Object
    },
    safari_insurance: {
      type: Object
    },
    climbing_insurance_required: {
      type: Boolean
    },
    safari_insurance_required: {
      type: Boolean
    },
    medical_clearance_required: {
      type: Boolean
    },
    requirements: {
      type: Object
    }
  },
  validations: {
    personal: {
      email: { email },
      emergency_contact_email: { email },
      phone: {},
      emergency_contact_phone: {},
      dob: {
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date('1930-01-01').setHours(0, 0, 0, 0)) : true
        },
        maxValue(val) {
          return val ? new Date(val) < new Date() : true
        },
      },
      passport_expiration_date: {
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        },
      },
    },
    climbing_insurance: {
      climbing_insurance_company: { required },
      climbing_insurance_number: { required },
      climbing_insurance_coverage_start: {
        required,
        maxValue(val) {
          return new Date(val) < new Date(this.climbing_insurance.climbing_insurance_coverage_end)
        },
      },
      climbing_insurance_coverage_end: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        },
      },
      climbing_insurance_emergency_phone: {}
    },
    safari_insurance: {
      safari_insurance_company: { required },
      safari_insurance_number: { required },
      safari_insurance_coverage_start: {
        required,
        maxValue(val) {
          return new Date(val) < new Date(this.safari_insurance.safari_insurance_coverage_end)
        },
      },
      safari_insurance_coverage_end: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        },
      },
      safari_insurance_emergency_phone: {}
    }
  },
  data() {
    return {
      show_common: false,
      show_personal: true,
      show_climbing: false,
      show_safari: false,
      genders_options: [],
      countries_options: [],
      residences_options: [],
      languages_options: [],
      languages_common_options: [],
      food_options: [],
      categories_options: [],
      tour_operators_options: [],
      tour_operator_managers_options: [],
      managers_options: [],
      allergies_switcher: false,
      // preferences_switcher: false
    }
  },
  created() {
    getGenders().then(res => { this.genders_options = res.data })
    getCountries().then(res => { this.countries_options = res.data })
    getResidences().then(res => { this.residences_options = res.data })
    getLanguages().then(res => { this.languages_options = res.data })
    getLanguages(true).then(res => { this.languages_common_options = res.data })
    getFoodPreferences().then(res => { this.food_options = res.data })
    getClientsCategories(true).then(res => { this.categories_options = res.data })
    getUsers({ group: 'sales_manager', is_active: true }).then(response => {
      this.managers_options = response.data
    })
    getClientsTourOperators().then(res => {
      this.tour_operators_options = res.data.results
      if (this.common.tour_operator) {
        getClientsTourOperatorManagers({ tour_operator: this.common.tour_operator.id })
          .then(res => { this.tour_operator_managers_options = res.data })
      }
    })
    if (this.personal.food_allergy) this.allergies_switcher = true
  },
  watch: {
    allergies_switcher(val) {
      if (!val) {
        this.personal.food_allergy = null
      }
    },
  },
  computed: {
    isClimbingFilled() {
      let count = 0
      for (const prop in this.climbing_insurance) {
        if (this.climbing_insurance[prop]) count += 1
      }
      return count
    },
    isSafariFilled() {
      let count = 0
      for (const prop in this.safari_insurance) {
        if (this.safari_insurance[prop]) count += 1
      }
      return count
    },
    isPersonalFilled() {
      let count = 0
      for (const prop in this.personal) {
        if (this.personal[prop] && !['phone_telegram', 'phone_whatsapp', 'emergency_contact_phone_telegram', 'emergency_contact_phone_whatsapp', 'food_gluten_free', 'food_lactose_free'].includes(prop)) {
          count += 1
          if (prop === 'crop' && this.personal.crop.photo_url === null) {
            count -= 1
          }
        }
      }
      return count
    },
    isCommonFilled() {
      let count = 0
      for (const prop in this.common) {
        if (this.common[prop] && this.common[prop].length !== 0) count += 1
      }
      return count
    },
    // commonCounts() {
    //   return this.isCommonFilled !==  Object.keys(this.common).length ? `(${this.isCommonFilled}/${Object.keys(this.common).length} Completed)` : '(Completed)'
    // },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_operations_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
  },
  methods: {
    onCopyInsurance(data, target_field, source_field) {
      this[`${target_field}_insurance`][`${target_field}_insurance_company`] = data[`${source_field}_insurance_company`]
      this[`${target_field}_insurance`][`${target_field}_insurance_coverage_end`] = data[`${source_field}_insurance_coverage_end`]
      this[`${target_field}_insurance`][`${target_field}_insurance_coverage_start`] = data[`${source_field}_insurance_coverage_start`]
      this[`${target_field}_insurance`][`${target_field}_insurance_emergency_phone`] = data[`${source_field}_insurance_emergency_phone`]
      this[`${target_field}_insurance`][`${target_field}_insurance_number`] = data[`${source_field}_insurance_number`]
      this.$notify({
        type: 'success',
        title: 'Data copied successfully. Don\'t forget to save.',
      })
    },
    onTourOperatorChange() {
      if (this.common.tour_operator) {
        getClientsTourOperatorManagers({ tour_operator: this.common.tour_operator })
          .then(res => { this.tour_operator_managers_options = res.data.results })
      } else {
        this.common.tour_operator_manager = null
        this.tour_operator_managers_options = []
      }
    },
    onChangeRUToUS(value, prop) {
      let answer = ''
      const converter = {
        'а': 'a',
        'б': 'b',
        'в': 'v',
        'г': 'g',
        'д': 'd',
        'е': 'e',
        'ё': 'e',
        'ж': 'zh',
        'з': 'z',
        'и': 'i',
        'й': 'y',
        'к': 'k',
        'л': 'l',
        'м': 'm',
        'н': 'n',
        'о': 'o',
        'п': 'p',
        'р': 'r',
        'с': 's',
        'т': 't',
        'у': 'u',
        'ф': 'f',
        'х': 'h',
        'ц': 'c',
        'ч': 'ch',
        'ш': 'sh',
        'щ': 'sch',
        'ь': '',
        'ы': 'y',
        'ъ': '',
        'э': 'e',
        'ю': 'yu',
        'я': 'ya',
        'А': 'A',
        'Б': 'B',
        'В': 'V',
        'Г': 'G',
        'Д': 'D',
        'Е': 'E',
        'Ё': 'E',
        'Ж': 'Zh',
        'З': 'Z',
        'И': 'I',
        'Й': 'Y',
        'К': 'K',
        'Л': 'L',
        'М': 'M',
        'Н': 'N',
        'О': 'O',
        'П': 'P',
        'Р': 'R',
        'С': 'S',
        'Т': 'T',
        'У': 'U',
        'Ф': 'F',
        'Х': 'H',
        'Ц': 'C',
        'Ч': 'Ch',
        'Ш': 'Sh',
        'Щ': 'Sch',
        'Ь': '',
        'Ы': 'Y',
        'Ъ': '',
        'Э': 'E',
        'Ю': 'Yu',
        'Я': 'Ya'
      }

      for (let i = 0; i < value.length; ++i) {
        if (converter[value[i]] === undefined) {
          answer += value[i]
        } else {
          answer += converter[value[i]]
        }
      }
      this.personal[prop] = answer
    },
    onCheckForm(data, type) {
      if (type === 'personal') {
        this.$v.personal.$touch()
        if (this.$v.personal.$invalid) {
          this.$notify({
            type: 'info',
            title: 'Check that the form fields are filled in correctly',
          })
        } else {
          if (this.personal.crop.coords && !this.personal.crop.photo) {
            this.$refs.submit_personal.preload = true
            this.$refs.cropper.sendCrop()
              .then(() => { this.sendForm(data, type) })
              .catch(() => { this.$refs.submit_personal.preload = false })
          } else {
            this.sendForm(data, type)
          }
        }
      } else if (type === 'climbing') {
        this.$v.climbing_insurance.$touch()
        if (this.$v.climbing_insurance.$invalid) {
          this.$notify({
            type: 'info',
            title: 'Check that the form fields are filled in correctly',
          })
        } else {
          this.sendForm(data, type)
        }
      } else if (type === 'safari') {
        this.$v.safari_insurance.$touch()
        if (this.$v.safari_insurance.$invalid) {
          this.$notify({
            type: 'info',
            title: 'Check that the form fields are filled in correctly',
          })
        } else {
          this.sendForm(data, type)
        }
      } else {
        this.sendForm(data, type)
      }
    },
    sendForm(data, type) {
      if (type === 'personal') {
        this.$refs.submit_personal.preload = true
        patchClients(this.$route.params.id, this.normalizeForm(data))
          .finally(() => { this.$refs.submit_personal.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Data saved successfully',
            })
            this.$emit('getClientData')
          })
      } else if (type === 'climbing') {
        this.$refs.submit_climbing.preload = true
        patchClients(this.$route.params.id, data)
          .finally(() => { this.$refs.submit_climbing.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Data saved successfully',
            })
          })
      } else if (type === 'safari') {
        this.$refs.submit_safari.preload = true
        patchClients(this.$route.params.id, data)
          .finally(() => { this.$refs.submit_safari.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Data saved successfully',
            })
          })
      } else {
        this.$refs.submit_common.preload = true
        patchClients(this.$route.params.id, this.normalizeCommon(data))
          .finally(() => { this.$refs.submit_common.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Data saved successfully',
            })
          })
      }
    },
    normalizeCommon(data) {
      const normalizedForm = { ...data }

      if (normalizedForm.category && typeof normalizedForm.category !== 'string') normalizedForm.category = normalizedForm.category.code
      // if (normalizedForm.tags.length && normalizedForm.tags[0].name) normalizedForm.tags = normalizedForm.tags.id
      // if (normalizedForm.tour_operator && typeof normalizedForm.tour_operator !== 'number') normalizedForm.tour_operator = normalizedForm.tour_operator.id
      // if (normalizedForm.tour_operator_manager && typeof normalizedForm.tour_operator_manager !== 'number') normalizedForm.tour_operator_manager = normalizedForm.tour_operator_manager.id

      return normalizedForm
    },
    normalizeForm(data) {
      const normalizedForm = { ...data }

      if (normalizedForm.citizenship && typeof normalizedForm.citizenship !== 'string') {
        normalizedForm.citizenship = normalizedForm.citizenship.code
      }
      if (normalizedForm.food_preference && typeof normalizedForm.food_preference !== 'number') {
        normalizedForm.food_preference = normalizedForm.food_preference.id
      }
      if (normalizedForm.residence && typeof normalizedForm.residence !== 'string') {
        normalizedForm.residence = normalizedForm.residence.code
      }
      if (normalizedForm.passport_copy && normalizedForm.passport_copy.id) {
        normalizedForm.passport_copy = normalizedForm.passport_copy.id
      } else normalizedForm.passport_copy = null
      if (normalizedForm.residence_permit_copy && normalizedForm.residence_permit_copy.id) {
        normalizedForm.residence_permit_copy = normalizedForm.residence_permit_copy.id
      } else normalizedForm.residence_permit_copy = null
      delete normalizedForm.crop.crop_url
      delete normalizedForm.crop.photo_url
      return normalizedForm
    },
  }
}
</script>

<style lang="sass" scoped>
.personal__maint
  margin-bottom: 12px
  color: #181818
  font-size: 16px
  font-weight: 600

.personal__subt
  margin-bottom: 20px
  color: #181818
  font-weight: 500

.personal__note
  display: flex
  align-items: center
  gap: 15px
  margin-bottom: 20px
  padding: 8px 10px
  border: 1px solid #ffa51f

  p
    color: #404040
    font-size: 12px
    line-height: 18px

.personal__text
  margin-bottom: 15px
  color: #676767
  font-size: 13px

.personal__last-update
  margin-bottom: 22px
  color: #959595
  font-size: 13px

.slide-enter-active
  transition-duration: 0.3s
  transition-timing-function: ease-in

.slide-leave-active
  transition-duration: 0.3s
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1)

.slide-enter-to, .slide-leave
  max-height: 768px
  overflow: hidden

.slide-enter, .slide-leave-to
  overflow: hidden
  max-height: 0

.slide-small-enter-active
  transition-duration: 0.3s
  transition-timing-function: ease-in

.slide-small-leave-active
  transition-duration: 0.3s
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1)

.slide-small-enter-to, .slide-small-leave
  max-height: 147px
  overflow: hidden

.slide-small-enter, .slide-small-leave-to
  overflow: hidden
  max-height: 0
</style>
